function initBlogNavbar() {
  function debounce(func, delay = 50) {
  let timeoutId;

  return function () {
    const context = this;
    const args = arguments;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

  const navContainer = document.querySelector(".table-of-contents-fixed");
  const scrollContainer = document.querySelector(".scroll-container");
  const navIcon = document.querySelectorAll(".nav-icon");
  const articleTitle = Array.from(
    document.querySelectorAll("[data-blog-title]")
  );
  const linkList = Array.from(document.querySelectorAll("[allow-hash-change]"));
  const getHTMLStyle = window
    .getComputedStyle(document.documentElement)
    ["scroll-padding-top"].split("px");
  const HTMLScrollPaddingTop = getHTMLStyle.length === 2 ? +getHTMLStyle[0] : 0;
  const postContent = document.querySelector("[data-post-content]");
  const postContentHeight = postContent.clientHeight;
  const defaultExpand = true;
  console.log(
    navContainer,
    scrollContainer,
    navIcon,
    articleTitle,
    linkList,
    HTMLScrollPaddingTop,
    postContentHeight
  );
  if (defaultExpand) {
    navContainer.classList.remove("nav-close");
  }

  articleTitle.forEach((item) => {
    !item.id &&
      (item.id =
        "H-" +
        item.textContent
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\p{L}\p{N}-]+/gu, "")
          .trim());
    linkList.map((link) => {
      if (link.textContent.trim() === item.textContent.trim()) {
        link.href = "#" + item.id;
      }
    });
  });

  const tableTitle = Array.from(
    document.querySelectorAll(".table-of-contents li")
  );
  Array.from(navIcon).forEach((icon) => {
    icon.addEventListener("click", function () {
      if (this.parentElement.classList.contains("auto-expand")) {
        this.parentElement.classList.remove("auto-expand");
        return;
      }
      this.parentElement.classList.toggle("h2Title-active");
    });
  });

  let activeTitleIndex = undefined;
  const showChildList = (ele) => {
    if (window.getComputedStyle(ele).visibility === "hidden") {
      ele.parentElement.parentElement.classList.add("auto-expand");
    }
  };
  const DebounceScrollTo = debounce(function (distanceTop, fixedTop) {
    if (!distanceTop) return;
    const willDis = distanceTop + scrollContainer.scrollTop - fixedTop - 60;

    if (Math.abs(scrollContainer.scrollTop - willDis) < 25) return;
    scrollContainer.scrollTo({
      top: willDis < 50 ? 0 : willDis,
      left: 0,
      behavior: "smooth",
    });
  }, 10);
  const scrollHandle = debounce(function (fixedTop) {
    let topList = articleTitle.map((item, index) => {
      let distanceTop = item.getBoundingClientRect().top;
      return {
        value: Math.abs(distanceTop - HTMLScrollPaddingTop),
        originValue: distanceTop,
        ele: item,
        index,
      };
    });

    let minTop = topList.sort((a, b) => a.value - b.value)[0];

    let index = minTop.index;
    let currentNavTitle = tableTitle[index];
    let postTop = postContent.getBoundingClientRect().top;

    if (postContentHeight >= Math.abs(postTop) && postTop < 0) {
      DebounceScrollTo(currentNavTitle.getBoundingClientRect().top, fixedTop);
      if (
        currentNavTitle.classList.contains("h2-nav") &&
        !currentNavTitle.classList.contains("auto-expand")
      ) {
        currentNavTitle.classList.add("auto-expand");
      }
      showChildList(currentNavTitle);

      if (activeTitleIndex !== undefined) {
        tableTitle[activeTitleIndex].classList.remove("h2Title-scroll-active");
      }
      currentNavTitle.classList.add("h2Title-scroll-active");
      activeTitleIndex = index;
    }
  }, 100);

  const scrollHandleFun = scrollHandle.bind(
    null,
    navContainer.computedStyleMap().get("top").value
  );
  window.addEventListener("scroll", scrollHandleFun);

  const close = document.querySelector(".table-of-contents-fixed .close");
  const expand = document.querySelector(".expand-icon");
  const closeFun = () => {
    navContainer.classList.add("nav-close");
  };
  close.addEventListener("click", closeFun);
  const expandFun = () => {
    navContainer.classList.remove("nav-close");
  };
  expand.addEventListener("click", expandFun);

  window.addEventListener("beforeunload", (event) => {
    window.removeEventListener("scroll", scrollHandleFun);
    close.removeEventListener("click", closeFun);
    expand.removeEventListener("click", expandFun);
  });

  const btn = document.querySelector(".mobile-navbar");
  btn && btn.addEventListener("click", openMenu);
  const modalContainer = document.querySelector(".modal-container");
  const modal = document.querySelector(".blog-nav-modal");
  function openMenu() {
    modalContainer?.classList.add("show");
    modal?.classList.add("show");
  }

  function closeMenu() {
    modalContainer.classList.remove("show");
    modal.classList.remove("show");
  }
  modalContainer && modalContainer.addEventListener("click", closeMenu);

  modal &&
    modal.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        closeMenu();
      }
      e.stopPropagation();
    });
}
initBlogNavbar();
